import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state:{
		totalNum:'',
		// province_id:'',   //高考省份0
		// major_id:1,    //艺考专业0
		// unified_exam:'',  //统考成绩0
		// exams_scores:0,   //成绩0
		// score1:0,  //乐理成绩
		// score2:0,  // 练耳成绩
		
		// academic_level:'',  //文化课水平0
		// major_level:'',  // 专业水平0
		
		// school_id:'',  //意向院校0
		// school:'请选择意向院校'
	},
	actions:{
		
	},
	mutations:{
// 		updateAcademic(state, academic_level) {
// 		    state.academic_level = academic_level
// 		},
// //		高考省份
// 		updateProvince (state, province_id) {
// 		    state.province_id = province_id
// 		},
// //		艺考专业
// 		updateMajor (state, major_id) {
// 		    state.major_id = major_id
// 		},
// //		统考分数
// 		updateUnified_exam (state, unified_exam) {
// 		    state.unified_exam = unified_exam
// 		},

	}
})
